import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getReadoutName } from '../../utils/nameFormat';
export const addReadoutFieldStmtInstruction = `
#### Add readout field

- Syntax: \`add readoutField <field_name> in <readout_name>;\`
- Example: \`add readoutField name in ${getReadoutName('Option')};\`
- Example: \`add readoutField category.name in ${getReadoutName('Variant')};\` (Use \`.property_name\` when accessing specific attributes within a related entity is required.)
`;
export const stmtAddReadoutField = ({ readoutFieldName, readoutName }) => {
    return `add readoutField ${readoutFieldName} in ${readoutName};`;
};
export const addReadoutFieldHandler = createStructureStatementHandler({
    type: 'add readoutField',
    parse: line => {
        const match = /^add (readout|detail)Field (?<readoutFieldName>[\w.]+) in (?<readoutName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'add readoutField',
                readoutFieldName: match.groups.readoutFieldName,
                readoutName: match.groups.readoutName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addReadoutField({
                readoutFieldName: stmt.readoutFieldName,
                readoutName: stmt.readoutName,
            });
        });
    },
});
//# sourceMappingURL=AddReadoutFieldStmt.js.map